var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"visible":_vm.showDialog,"width":_vm.modalWidth,"top":"25vh","modal-append-to-body":false,"before-close":_vm.handleClose,"close-on-click-modal":false,"custom-class":"custom-scrollable"},on:{"update:visible":function($event){_vm.showDialog=$event}}},[_c('commission-box',{on:{"closeDialog":_vm.closeDialog}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }